import React, { useEffect, useMemo, forwardRef, useCallback } from 'react';
import { Button, Form } from 'antd'
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { FieldTypes, generateFormFields, parseSelectOptions } from 'utils/formUtils';
import GenericMappingForm from '../GenericMappingForm';
import _ from 'lodash';
import { useRef } from 'react';
import { useState } from 'react';

const initialFormValues = {
  product: undefined,
  subProduct: undefined,
  environment: undefined,
  tenant: undefined,
  projectList: [{ namespaceId: undefined }]
};

export const DELIMITER = ":";
export const PROJECT_DELIMITER = ";"


const EndorLabsMappingForm = forwardRef(({ disableProjectFields = false, ...props }, ref) => {
  const namespaceRef = useRef({});
  const namespaceProjectRef = useRef({});
  const projectsApiRef = useRef({})
  const [form] = Form.useForm();
  const cancelRef = useRef([]);
  const [initialValues] = useState(() => {
    if (props.record) {
      return [];
    }
    return [{ ...initialFormValues }];
  });
  // const [values, setValues] = useState(initialValues);


  const [mappedProjectList] = useState(() => {
    // this state contains the already mapped namespace/projects
    // This is stored because the project and project dropdowns are paginated
    // and if the option selected is not on 2st page, then the ID is displayed as this is how select works
    if (props.record) {
      const { namespaceId, namespaceName, tenantId, tenantName } = props.record;
      const namespaceIdArray = namespaceId.split(",");
      const namespaceNameArray = namespaceName.split(",");
      const namespaceArray = [], projectsArray = []
      _.forEach(namespaceIdArray, (namespace, i) => {
        // there is chance of projectName like test:abc 
        const [namespaceId, projectId] = namespace.split(DELIMITER);
        const index = namespaceNameArray[i].lastIndexOf(DELIMITER)

        console.log(namespaceId, projectId, index, namespaceNameArray, 'bala')

        const _namespaceName = namespaceNameArray[i].substring(0, index === -1 ? undefined : index);
        const _projectName = index === -1 ? undefined : namespaceNameArray[i].substring(index + 1);
        
        namespaceArray.push({ id: namespaceId, name: _namespaceName });

        if (projectId) {
          const projectNameArray = _projectName.split(PROJECT_DELIMITER);
          _.forEach(projectId.split(PROJECT_DELIMITER), (verId, index) => {
            projectsArray.push({ id: verId, name: projectNameArray[index] });
          })
        }
      });

      return {
        tenant: [{ id: tenantId, name: tenantName }],
        namespace: _.uniqBy(namespaceArray, "id"),
        namespaceProject: _.uniqBy(projectsArray, "id"),
      }
    }
    return { tenant: [], namespace: [], namespaceProject: [] }
  })

  const projectsRef = useRef({ tenant: mappedProjectList.tenant, namespace: mappedProjectList.namespace, namespaceProject: mappedProjectList.namespaceProject });


  useEffect(() => {
    // cancelling all project APIs on component unmount
    const cancels = cancelRef.current;
    return () => _.forEach(cancels, cancel => cancel());
  }, []);

  const fetchProjects = useCallback((key, params) => {
    let { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, { login_id: props.loginConfigId, ...params });
    promise = promise.then((response) => {
      // merging the already mapped namespace/project/tenant to the fetched list so that if the selected value is not in the option list
      // then id should not be displayed
      if (mappedProjectList[key].length > 0 && !_.isEmpty(response.projects)) {
        response.projects = [...response.projects, ...mappedProjectList[key]];
      }
      projectsRef.current[key] = _.uniqBy([...projectsRef.current[key], ...response.projects], 'id');
      return response;
    });
    return { promise, cancel };
  }, [props.loginConfigId, props.toolName, mappedProjectList])

  const fetchTenant = useCallback((params) => {
    return fetchProjects("tenant", params)
  }, [fetchProjects]);

  const fetchNameSpace = useCallback((params) => {
    return fetchProjects("namespace", params)
  }, [fetchProjects])

  const fetchNameSpaceProjects = useCallback((params) => {
    return fetchProjects("namespaceProject", params)
  }, [fetchProjects])

  const getExtraFieldsData = useCallback((config) => {
    const { tenantId, projectList } = config;

    const tenantName = _.find(projectsRef.current.tenant, { id: tenantId })?.name;

    const namespaceNameList = [];

    const namespaceIdList = _.map(projectList, ({ namespaceId, project }) => {
      const nameSpaceName = _.find(projectsRef.current.namespace, { id: namespaceId })?.name;
      const projectName = _.isArray(project) ? _.map(project, v => _.find(projectsRef.current.namespaceProject, { id: v })?.name).join(PROJECT_DELIMITER) : _.find(projectsRef.current.namespaceProject, { id: project })?.name;
      if (project) {
        namespaceNameList.push(nameSpaceName + DELIMITER + projectName);
        return `${namespaceId}${DELIMITER}${_.isArray(project) ? project.join(PROJECT_DELIMITER) : project}`;
      }
      namespaceNameList.push(nameSpaceName);
      return namespaceId;
    });


    return ({
      tenantId,
      tenantName,
      namespaceId: namespaceIdList.join(),
      namespaceName: namespaceNameList.join(),
      //send the property received in config
      ...(config.discovery_config_id && { discovery_config_id: config.discovery_config_id })
    });
  }, []);

  const parseExtraFieldsDataFromResponse = useCallback((config) => {
    const { namespaceId, tenantId } = config;
    const namespaceWithProjects = namespaceId?.split(',');
    const namespacelist = _.map(namespaceWithProjects, namespceWithProject => {
      const index = namespceWithProject.lastIndexOf(DELIMITER);
      if (index !== -1) {
        const namespaceId = namespceWithProject.substring(0, index);
        const project = namespceWithProject.substring(index + 1, namespceWithProject.length);
        return { namespaceId, project: project.split(PROJECT_DELIMITER) };
      }
      return { namespaceId: namespceWithProject }
    });

    return ({
      tenantId,
      projectList: namespacelist,
    });
  }, []);

  const onValuesChange = useCallback((values, ...args) => {
    if (values.configurations) {
      let isNameSpaceChanged = false;
      const formValues = form.getFieldsValue();
      _.forEach(values.configurations, (configs, index) => {

        // If project list is greater than 1, means that a new blank row is added
        // no need to clear the project fields
        console.log()
        if (!configs || !configs.projectList || _.compact(configs.projectList).length > 1) {
          return;
        }

        // since this is a list field, onchange will trigger only for the changed row.
        // if change is done at 2nd row, data received in this callback will only contain 2nd row data
        // configs.projectList is given as string when we search in the field
        if (!configs || _.isString(configs.projectList)) {
          return;
        }
        _.forEach(configs.projectList, (object, i) => {

          // since this is a list field, onchange will trigger only for the changed row.
          // if change is done at 2nd row, data received in this callback will only contain 2nd row data
          // Also checking if the object contains `project` and nothing else 
          // because we need to reset the project field only if the project is changed
          // and this change is also triggered when rows are added or deleted, so we need to ignore it
          if (object && object.namespaceId && Object.keys(object).length === 1) {
            isNameSpaceChanged = true;
            formValues.configurations[index].projectList[i].project = undefined;
          }
        })
      });
      if (isNameSpaceChanged) {
        form.setFieldsValue(formValues);
      }
    }
  }, [form]);

  const projectListRender = useCallback((listField) => {

    // This is a hack, we are storing the api method for project in a ref
    // as it is dependant on `listField` param of this method
    // that is why we cannot move it to `useCallback`
    // For a `listField.name` we are defining the method only once and using the method if it alreadr exists in the ref
    // Reason for doing this is that the method reference will always change and will trigger API on every render
    // It also causes a visible bug on UI as when the API triggers, the selected value disappears as we don't show value when data is loading

    let namespaceProjectAPI = projectsApiRef.current[listField.name];
    if (!namespaceProjectAPI) {
      namespaceProjectAPI = projectsApiRef.current[listField.name] = ({ listFieldName: nestedListFieldName, ...params }) => {
        const allConfigs = form.getFieldsValue().configurations;

        const tenantId = allConfigs[listField.name].tenantId;
        const tenantName = _.find(projectsRef.current.tenant, { id: tenantId })?.name;

        const namespaceId = allConfigs[listField.name]?.projectList[nestedListFieldName]?.namespaceId;
        const namespaceName = _.find(projectsRef.current.namespace, { id: namespaceId })?.name;
        const project = { organisation: `${tenantName}:${tenantId}`, project: namespaceName }
        if (!tenantId || !namespaceId) {
          return { promise: Promise.resolve([]), cancel: _.noop };
        }
        return fetchNameSpaceProjects({ ...params, ...project });
      }
    }
    // 

    const __fields = [{
      name: 'namespaceId',
      placeholder: "Namespace",
      type: FieldTypes.SELECT_WITH_PAGINATED_DATA,
      colSpan: 10,
      props: {
        showValueOnload: false,
        optionsMutator: (namespace) => {
          const selected = _.compact(_.map(form.getFieldsValue().configurations?.[listField.name]?.projectList, p => p?.namespaceId));
          return _.map(namespace, p => ({ ...p, disabled: _.includes(selected, p.id) }));
        },
        setExtraProps: (field, nestedListField) => {
          const allConfigs = form.getFieldsValue().configurations;
          const tenantId = allConfigs[listField.name]?.tenantId;
          const tenantName = _.find(projectsRef.current.tenant, { id: tenantId })?.name;
          if (!namespaceRef.current[tenantId]) {
            namespaceRef.current[tenantId] = { organisation: `${tenantName}:${tenantId}` };
          }

          return {
            api: tenantId && fetchNameSpace,
            apiParams: namespaceRef.current[tenantId],
            resetOptionsProp: tenantId,
            disabled: !tenantId || disableProjectFields
          }
        }
      },
      rules: [{ required: true, message: 'Endors Lab Namespace is required' }]
    }, {
      name: 'project',
      placeholder: "Projects",
      type: FieldTypes.SELECT_WITH_PAGINATED_DATA,
      colSpan: 10,
      props: {
        setExtraProps: (field, nestedListField) => {
          const allConfigs = form.getFieldsValue().configurations;

          const tenantId = allConfigs[listField.name].tenantId;
          const tenantName = _.find(projectsRef.current.tenant, { id: tenantId })?.name;

          const namespaceId = allConfigs[listField.name]?.projectList[nestedListField.name]?.namespaceId;
          const namespaceName = _.find(projectsRef.current.namespace, { id: namespaceId })?.name;

          if (!namespaceProjectRef.current[`${tenantId}:${namespaceId}`]) {
            namespaceProjectRef.current[`${tenantId}:${namespaceId}`] = { organisation: `${tenantName}:${tenantId}`, project: namespaceName };
          }
          return {
            api: namespaceProjectAPI,
            mode: "multiple",
            resetOptionsProp: JSON.stringify(namespaceProjectRef.current[`${tenantId}:${namespaceId}`]),
            disabled: !tenantId || !namespaceId || disableProjectFields
          }
        }
      },
    }, {
      name: "add",
      colSpan: 2,
      render: ({ remove, name, fields }) => {
        return <Button disabled={fields.length === 1} type='dashed' onClick={() => { remove(name) }}>-</Button>;
      }
    }]

    return (
      <div className='m-b-sm'>
        <Form.List name={[listField.name, "projectList"]}>
          {(fields, { add, remove }) => {
            return (
              <div>
                {_.map(fields, field => {
                  return generateFormFields(__fields, 10, { ...field/* , name: [listField.name, field.name] */, add, remove, fields }, field.name);
                })}
                <Button size='small' type='dashed' onClick={() => add({ project: undefined })} disabled={disableProjectFields}>+ Add Project</Button>
              </div>
            )
          }}
        </Form.List>
      </div>
    )
  }, [disableProjectFields, form, fetchNameSpace, fetchNameSpaceProjects]);

  const _fields = useMemo(() => [
    {
      name: "tenantId",
      colSpan: 10,
      type: FieldTypes.SELECT,
      label: "Tenant",
      required: true,
      disabled: disableProjectFields,
      props: {
        autoFocus: !disableProjectFields,
        api: fetchTenant,
        parseSelectOptions: res => parseSelectOptions(res.projects)
      }
    },
    {
      name: '',
      type: FieldTypes.LABEL,
      colSpan: 14
    },
    {
      name: "label",
      type: FieldTypes.LABEL,
      value: <b className='required-mark'>Namespaces</b>,
      style: { marginBottom: -24 },
      colSpan: 10
    }, {
      name: "label",
      type: FieldTypes.LABEL,
      value: <b>Projects</b>,
      style: { marginBottom: -24 },
      colSpan: 10
    }, {
      name: (listField) => [listField.name, "projectList"],
      render: projectListRender
    },
    {
      type: FieldTypes.DIVIDER
    }], [projectListRender, fetchTenant, disableProjectFields]);

  return (
    <GenericMappingForm
      form={form}
      ref={ref}
      getExtraFieldsData={getExtraFieldsData}
      parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
      extraFields={_fields}
      formDefaultValues={initialValues}
      newRowDefaultValue={initialValues[0]}
      {...props}
      onValuesChange={onValuesChange}
    />
  )
})

export default EndorLabsMappingForm;
